import { defaultApiInt, newApiFetchV2 } from "./utils";

export const getKpiUpdateData = (): defaultApiInt => newApiFetchV2("/admin/kpi_update/get/", {});
